// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__3bbWI","text":"NotFound_text__1Nid3","title":"NotFound_title__23RiO"};